import { ModuleWithProviders, NgModule } from '@angular/core';
import { ApiConstant } from '../index';
import { AuthLazyModule } from './auth-lazy.module';
import { API_TOKEN } from './types';
import { InvitationService } from './services/invitation.service';

@NgModule({
    imports: [AuthLazyModule],
    exports: [AuthLazyModule],
    providers: [InvitationService]
})
export class AuthModule {
    static forRoot(apiConstantt: ApiConstant): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                { provide: API_TOKEN, useValue: apiConstantt },
            ],
        };
    }
}
